import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74ccd37c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col items-center" }
const _hoisted_2 = { class: "relative w-full h-8 rounded-sm bg-project-dark div-wrong" }
const _hoisted_3 = { class: "flex justify-between w-full mt-2 text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "absolute h-full rounded-sm bg-project2-dark div-right",
        style: _normalizeStyle({ width: `${_ctx.right}%` })
      }, "   ", 4)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, _toDisplayString(_ctx.right) + "%", 1),
      _createElementVNode("div", null, _toDisplayString(100 - _ctx.right) + "%", 1)
    ])
  ]))
}